import { render, staticRenderFns } from "./kpi-summary-card.vue?vue&type=template&id=b94dbafa&scoped=true"
import script from "./kpi-summary-card.vue?vue&type=script&lang=ts"
export * from "./kpi-summary-card.vue?vue&type=script&lang=ts"
import style0 from "./kpi-summary-card.vue?vue&type=style&index=0&id=b94dbafa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94dbafa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b94dbafa')) {
      api.createRecord('b94dbafa', component.options)
    } else {
      api.reload('b94dbafa', component.options)
    }
    module.hot.accept("./kpi-summary-card.vue?vue&type=template&id=b94dbafa&scoped=true", function () {
      api.rerender('b94dbafa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula-step/kpi-summary-card/kpi-summary-card.vue"
export default component.exports